<div class="map-row">
    <div class="map-sec">
        @if (mapReady | async) {
        <div id="map" class="g-map"></div>
        }
    </div>
</div>
